import * as React from 'react'
import MUIRadio from '@mui/material/Radio'

const Radio = (props) => <MUIRadio {...props} />

export default Radio
